<template>
  <div class="pa-4">
    <primary-grant-form
      :user-id="userId"
      @close="onClose"
      @saved="onGrantSaved"
      @on-grant-deleted="onClose"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import PrimaryGrantForm from "@/views/grants/PrimaryGrantForm";
import { useSnackbar } from "@/plugins/snackbar";
import { useMetaStore } from "@/stores/meta";

const route = useRoute();
const router = useRouter();
const snackbar = useSnackbar();
const metaStore = useMetaStore();

const userId = computed(() => route.params.user_id);

const onClose = async () => {
  router.back();
  await router.replace({
    name: "grants.index",
  });
};

const onGrantSaved = async () => {
  snackbar.success("Informações salvas com sucesso");
  await onClose();
};

onMounted(() => {
  metaStore.setTitle("Alterar Acesso");
});
</script>
